<script lang="ts">
  import classnames from "classnames"
	import { LinkAction } from "$lib/components/atoms/Link";

  export let showExpandButton = true
  export let itemsNumber = 9
  export let collapsed = true
</script>

<section
  class="{classnames('mosaic-course-modules', $$props.class)}"
  class:collapsed
  class:more-elements="{itemsNumber > 6}"
>
  <slot />
</section>
{#if showExpandButton}
  <div class="selector-expander">
    <LinkAction iconPos="end" icon="{collapsed ? 'plus' : 'minus'}" on:click="{() => (collapsed = !collapsed)}">
      {collapsed ? "Mostra di più" : "Mostra di meno"}
    </LinkAction>
  </div>
{/if}

<style type="text/scss" lang="scss" scoped>
  .mosaic-course-modules {
    @apply grid md:grid-cols-3 grid-flow-row-dense;
    @apply gap-grid-default;
  }

  /* Hide all but the first three elements */
  :global(.mosaic-course-modules.collapsed > *:nth-child(n + 4)) {
    @apply hidden;
  }
  :global(.mosaic-course-modules.collapsed > *:nth-child(-n + 3)) {
    @apply block;
  }

  /* Hide all but the first six elements in the tablet/desktop version */

  @screen md {
    :global(.mosaic-course-modules.collapsed > *:nth-child(n + 7)) {
      @apply hidden;
    }

    :global(.mosaic-course-modules.collapsed > *:nth-child(-n + 6)) {
      @apply block;
    }
  }

  .selector-expander {
    @apply flex justify-end;
    @apply mt-6;
    @apply md:hidden;
  }

  .more-elements + .selector-expander {
    @apply md:flex;
  }
</style>
